/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Cart,
  FleetShoppingList,
  FleetShoppingListCopyInput,
  FleetShoppingListCreateInput,
  FleetShoppingListDetail,
  FleetShoppingListUpdateInput,
  FleetShoppingListsList,
  SchemaValidationErrorResponse,
  StandardError,
  SuccessResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Fleet Shopping Lists
 */
export const fleetShoppingLists = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetShoppingListsList>(
      {url: `/fleets/${fleetSlug}/shopping-lists`, method: 'GET', signal
    },
      );
    }




export const getFleetShoppingListsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'shopping-lists'
    ] as const;
    }


export const getFleetShoppingListsQueryOptions = <TData = Awaited<ReturnType<typeof fleetShoppingLists>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetShoppingLists>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetShoppingListsQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetShoppingLists>>> = ({ signal }) => fleetShoppingLists(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetShoppingLists>>, TError, TData>
}

export type FleetShoppingListsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetShoppingLists>>>
export type FleetShoppingListsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Shopping Lists
 */

export function useFleetShoppingLists<TData = Awaited<ReturnType<typeof fleetShoppingLists>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetShoppingLists>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetShoppingListsQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Fleet Shopping List
 */
export const createFleetShoppingList = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetShoppingListCreateInput: MaybeRefOrGetter<FleetShoppingListCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetShoppingListCreateInput = toValue(fleetShoppingListCreateInput);

      return axiosClient<FleetShoppingList>(
      {url: `/fleets/${fleetSlug}/shopping-lists`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetShoppingListCreateInput, signal
    },
      );
    }




export const getCreateFleetShoppingListMutationKey = () => ['createFleetShoppingList'] as const;

export const getCreateFleetShoppingListMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetShoppingList>>, TError,CreateFleetShoppingListMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetShoppingList>>, TError,CreateFleetShoppingListMutationVariables, TContext> => {

const mutationKey = getCreateFleetShoppingListMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetShoppingList>>, CreateFleetShoppingListMutationVariables> = (props) => {
          const {fleetSlug,data} = props ?? {};

          return  createFleetShoppingList(fleetSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetShoppingListMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetShoppingList>>>
    export type CreateFleetShoppingListMutationBody = FleetShoppingListCreateInput
    export type CreateFleetShoppingListMutationError = ErrorType<ValidationError | StandardError>
    export type CreateFleetShoppingListMutationVariables = {fleetSlug: string;data: FleetShoppingListCreateInput}

    /**
 * @summary Create Fleet Shopping List
 */
export const useCreateFleetShoppingList = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetShoppingList>>, TError,CreateFleetShoppingListMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetShoppingList>>,
        TError,
        CreateFleetShoppingListMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetShoppingListMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Shopping List
 */
export const fleetShoppingList = (
    fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
id = toValue(id);

      return axiosClient<FleetShoppingListDetail>(
      {url: `/fleets/${fleetSlug}/shopping-lists/${id}`, method: 'GET', signal
    },
      );
    }




export const getFleetShoppingListQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'shopping-lists',id
    ] as const;
    }


export const getFleetShoppingListQueryOptions = <TData = Awaited<ReturnType<typeof fleetShoppingList>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetShoppingList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetShoppingListQueryKey(fleetSlug,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetShoppingList>>> = ({ signal }) => fleetShoppingList(fleetSlug,id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetShoppingList>>, TError, TData>
}

export type FleetShoppingListQueryResult = NonNullable<Awaited<ReturnType<typeof fleetShoppingList>>>
export type FleetShoppingListQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Shopping List
 */

export function useFleetShoppingList<TData = Awaited<ReturnType<typeof fleetShoppingList>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetShoppingList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetShoppingListQueryOptions(fleetSlug,id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Fleet Shopping List
 */
export const updateFleetShoppingList = (
    fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    fleetShoppingListUpdateInput: MaybeRefOrGetter<FleetShoppingListUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
id = toValue(id);
fleetShoppingListUpdateInput = toValue(fleetShoppingListUpdateInput);

      return axiosClient<FleetShoppingList>(
      {url: `/fleets/${fleetSlug}/shopping-lists/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetShoppingListUpdateInput, signal
    },
      );
    }




export const getUpdateFleetShoppingListMutationKey = () => ['updateFleetShoppingList'] as const;

export const getUpdateFleetShoppingListMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetShoppingList>>, TError,UpdateFleetShoppingListMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetShoppingList>>, TError,UpdateFleetShoppingListMutationVariables, TContext> => {

const mutationKey = getUpdateFleetShoppingListMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetShoppingList>>, UpdateFleetShoppingListMutationVariables> = (props) => {
          const {fleetSlug,id,data} = props ?? {};

          return  updateFleetShoppingList(fleetSlug,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetShoppingListMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetShoppingList>>>
    export type UpdateFleetShoppingListMutationBody = FleetShoppingListUpdateInput
    export type UpdateFleetShoppingListMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateFleetShoppingListMutationVariables = {fleetSlug: string;id: string;data: FleetShoppingListUpdateInput}

    /**
 * @summary Update Fleet Shopping List
 */
export const useUpdateFleetShoppingList = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetShoppingList>>, TError,UpdateFleetShoppingListMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetShoppingList>>,
        TError,
        UpdateFleetShoppingListMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetShoppingListMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Fleet Shopping List
 */
export const destroyFleetShoppingList = (
    fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
id = toValue(id);

      return axiosClient<SuccessResponse>(
      {url: `/fleets/${fleetSlug}/shopping-lists/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetShoppingListMutationKey = () => ['destroyFleetShoppingList'] as const;

export const getDestroyFleetShoppingListMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetShoppingList>>, TError,DestroyFleetShoppingListMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetShoppingList>>, TError,DestroyFleetShoppingListMutationVariables, TContext> => {

const mutationKey = getDestroyFleetShoppingListMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetShoppingList>>, DestroyFleetShoppingListMutationVariables> = (props) => {
          const {fleetSlug,id} = props ?? {};

          return  destroyFleetShoppingList(fleetSlug,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetShoppingListMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetShoppingList>>>

    export type DestroyFleetShoppingListMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyFleetShoppingListMutationVariables = {fleetSlug: string;id: string}

    /**
 * @summary Destroy Fleet Shopping List
 */
export const useDestroyFleetShoppingList = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetShoppingList>>, TError,DestroyFleetShoppingListMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetShoppingList>>,
        TError,
        DestroyFleetShoppingListMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetShoppingListMutationOptions(options), queryClient);
    }
    /**
 * @summary Copy Fleet Shopping List
 */
export const copyFleetShoppingList = (
    fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    fleetShoppingListCopyInput?: MaybeRefOrGetter<FleetShoppingListCopyInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
id = toValue(id);
fleetShoppingListCopyInput = toValue(fleetShoppingListCopyInput);

      return axiosClient<Cart>(
      {url: `/fleets/${fleetSlug}/shopping-lists/${id}/copy`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetShoppingListCopyInput, signal
    },
      );
    }




export const getCopyFleetShoppingListMutationKey = () => ['copyFleetShoppingList'] as const;

export const getCopyFleetShoppingListMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyFleetShoppingList>>, TError,CopyFleetShoppingListMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof copyFleetShoppingList>>, TError,CopyFleetShoppingListMutationVariables, TContext> => {

const mutationKey = getCopyFleetShoppingListMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof copyFleetShoppingList>>, CopyFleetShoppingListMutationVariables> = (props) => {
          const {fleetSlug,id,data} = props ?? {};

          return  copyFleetShoppingList(fleetSlug,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CopyFleetShoppingListMutationResult = NonNullable<Awaited<ReturnType<typeof copyFleetShoppingList>>>
    export type CopyFleetShoppingListMutationBody = FleetShoppingListCopyInput | undefined
    export type CopyFleetShoppingListMutationError = ErrorType<ValidationError | StandardError>
    export type CopyFleetShoppingListMutationVariables = {fleetSlug: string;id: string;data?: FleetShoppingListCopyInput}

    /**
 * @summary Copy Fleet Shopping List
 */
export const useCopyFleetShoppingList = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyFleetShoppingList>>, TError,CopyFleetShoppingListMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof copyFleetShoppingList>>,
        TError,
        CopyFleetShoppingListMutationVariables,
        TContext
      > => {
      return useMutation(getCopyFleetShoppingListMutationOptions(options), queryClient);
    }
